/** D4 烟花:eventFX;升空拖尾 + 顶端爆裂环 + 烛民欢呼。 */
import { Sprite } from 'pixi.js';
import { BaseEffect } from './base';
import { eventPool } from '../engine/ParticlePool';
import { scene } from '../engine/Scene';
import { TEX } from '../engine/Tex';
import { P } from '../engine/Palette';
import { LW, LH } from '../engine/Stage';
import { rand, pick } from '../engine/util';
import { sfx } from '../engine/Sfx';

const COLORS = [P.ember, P.emberHi, P.moon, 0xff8fce, 0x8ef0c0];

export class FireworksEffect extends BaseEffect {
  id = 'fireworks';
  private next = 0;
  private halos: { s: Sprite; age: number }[] = [];

  onStart() {
    this.tail = 3;
    scene.crowd?.cheer(this.dur);
  }

  onUpdate(dt: number) {
    this.next -= dt;
    if (this.next <= 0 && this.t < this.dur * 0.85) {
      this.next = rand(0.5, 1.3);
      this.launch(rand(LW * 0.3, LW * 0.7), rand(LH * 0.14, LH * 0.42));
    }
    // 爆炸闪白光晕:dt 驱动淡出
    for (let i = this.halos.length - 1; i >= 0; i--) {
      const h = this.halos[i]; h.age += dt;
      h.s.alpha = Math.max(0, 1 - h.age / 0.18);
      h.s.scale.set(0.4 + h.age * 1.2);
      if (h.age > 0.18) { h.s.destroy(); this.halos.splice(i, 1); }
    }
  }

  private launch(tx: number, ty: number) {
    const color = pick(COLORS);
    eventPool?.spawn({
      x: tx, y: this.island.surfaceYAt(LW * 0.5), vx: rand(-20, 20), vy: -rand(420, 500), ay: 260,
      life: 1.4, scale: 0.05, tint: color, alpha: 0.95, blend: 'add', texture: TEX.core(), fade: 'none',
      onUpdate: (p) => {
        // 升空拖尾
        if (Math.random() < 0.6) eventPool?.spawn({ x: p.x, y: p.y, vy: 20, life: 0.5, scale: 0.03, tint: P.ember, alpha: 0.6, blend: 'add', texture: TEX.glow() });
        if (!p.hit && (p.vy >= -20 || p.y <= ty)) { p.hit = true; p.life = 0; this.explode(p.x, p.y, color); }
      },
    });
  }

  private explode(x: number, y: number, color: number) {
    // 顶端闪白光晕(dt 驱动)
    const halo = new Sprite(TEX.glow()); halo.anchor.set(0.5); halo.blendMode = 'add'; halo.tint = 0xffffff; halo.scale.set(0.4); halo.position.set(x, y);
    this.g.addChild(halo);
    this.halos.push({ s: halo, age: 0 });
    const n = 90 + Math.floor(60 * this.k);
    for (let i = 0; i < n; i++) {
      const a = (i / n) * Math.PI * 2 + rand(-0.1, 0.1);
      const sp = rand(240, 320);
      eventPool?.spawn({
        x, y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp, ay: 90, life: rand(1, 1.4),
        scale: rand(0.02, 0.04), tint: pick([color, P.emberHi, P.moon]), alpha: 0.95, blend: 'add', texture: TEX.core(), fade: 'quad',
      });
    }
    sfx.play('boom', { delay: 0.3 });
  }
}
